<template>
	<div class="password-reset">
		<v-card class="rounded-lg password-reset-card">
			<h1>Resetear contraseña</h1>

			<div class="password-reset-form">
				<v-form v-model="valid" ref="form">
					<!-- Password text field -->
					<!-- Logic to show/hide password after label -->
					<v-text-field
						v-model="newPassword"
						label="Nueva contraseña"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="showPassword = !showPassword"
						:type="showPassword ? 'text' : 'password'"
						:rules="passwordValidator"
						@change="validateRepeatPassword"
					></v-text-field>

					<v-text-field
						ref="passwordRepeat"
						v-model="newPasswordRepeat"
						label="Repita nueva contraseña"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="showPassword = !showPassword"
						:type="showPassword ? 'text' : 'password'"
						:rules="repeatPasswordValidator"
					></v-text-field>

					<v-card-actions class="card-actions">
						<v-spacer></v-spacer>

						<!-- Reset password -->
						<v-btn
							color="success"
							@click="changePassword"
							:disabled="!valid || loading"
							:loading="loading"
							class="rounded-lg"
							elevation="0"
							>Cambiar contraseña</v-btn
						>
					</v-card-actions>

					<!-- End of form -->
				</v-form>
			</div>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios";

	export default {
		data() {
			return {
				newPassword: "",
				newPasswordRepeat: "",
				loading: false,
				showPassword: false,

				valid: false,
				passwordValidator: [
					(v) => {
						if (v !== "") {
							return (
								v.length >= 8 ||
								"La contraseña debe tener 8 carácteres al menos"
							);
						} else {
							return true;
						}
					},
				],
				notEmpty: [(v) => v !== "" || "Este campo no puede estar vacío"],
				repeatPasswordValidator: [
					(v) => v === this.newPassword || "Las contraseñas no coinciden",
				],
			};
		},
		methods: {
			validateRepeatPassword() {
				this.$refs.form.validate();
			},
			async changePassword() {
				try {
					this.$emit("loading", true);

					await axios.post("/user/reset-password", {
						password: this.newPassword,
						token: this.$route.params.token,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha cambiado exitosamente la contraseña",
					});
				} catch (error) {
					console.error(error);
					let errorToDisplay;

					if (error.response) {
						errorToDisplay = error.response.data;
						//Rest of the cases
					} else {
						errorToDisplay =
							"Ha ocurrido un error cambiando la contraseña, pruebe más tarde por favor";
					}
					this.$emit("snackbar-event", {
						color: "error",
						text: errorToDisplay,
					});
				} finally {
					this.$emit("loading", false);
					this.$router.push({ name: "UserLogin" });
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../scss/_mixins.scss";

	.password-reset {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 2em 0.5em;

		background-color: #f0f0f3;

		.password-reset-card {
			width: 100%;
			max-width: 500px;
			height: fit-content;
			padding: 2em;

			h1 {
				flex: 1;
				font-size: 1.5em;

				@include desktop() {
					font-size: 2em;
				}
			}

			.card-row {
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
				column-gap: 1em;
			}

			.password-reset-form {
				margin-top: 1em;

				.password-hint {
					margin: 2em 0 0;
					font-size: 0.9em;

					&[disabled] {
						color: rgba($color: #000000, $alpha: 0.38);
					}
				}

				.card-actions {
					margin-top: 2em;
					width: 100%;
					padding: 0;
				}
			}
		}
	}
</style>